<h2 mat-dialog-title class="mat-title">
    <span >{{'Application_Setup.header'|translate}}</span>
    
    <span class="close-dialog" (click)="cancel()">&#10006;</span>
  </h2>
  <mat-dialog-content [ngStyle]="{'justify-content': continueToAppSetUp?'start':'center'}">
    <div class="app-settings-container">
    @if (!continueToAppSetUp) {
    <div class="info_screen">
    <img class="logo" src="assets/img/Intro image_v1.svg">
      <span class="info_message">{{'Application_Setup.warning_message'|translate : {appName: data.appName} }}
    </span>
    <span class="continue_message"><p>{{'Application_Setup.continue_setup_message'|translate : {appName: data.appName} }}</p></span>
    </div>
    }
    @if (continueToAppSetUp) {
    <div>
      <span class="onboard-header">{{'Application_Setup.onboard_header'|translate }}</span>
        <div class="select-roles">
            <mat-label>{{'Application_Setup.select_roles'|translate}} <small>({{'Application_Setup.roles_message'|translate}})</small></mat-label>
            <div class="roles-container">
            @for (role of appRoles; track role) {
            <div class="role-row">
                <mat-checkbox color="primary" [disabled]="role.isDisabled" (change)="role.isSelected = !role.isSelected" [checked]="role.isSelected" (click)="$event.stopPropagation()">{{role?.name}}</mat-checkbox>
              </div>
              }
              </div>
        </div>
      <div class="configure-app">
        <mat-label>{{'Application_Setup.configure_app'|translate}}</mat-label>
        <div class="configure-app-container">
            <mat-slide-toggle color="primary" [checked]="isAppInternalOnly" (change)="isAppInternalOnly=!isAppInternalOnly" (click)="$event.stopPropagation()">{{'Application_Setup.configure_app_label'|translate}}
            </mat-slide-toggle>
            <span class="info-icon" [matTooltip]="'Application_Setup.internalapp_tooltip_message'|translate" matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 22 24" fill="none">
                <path d="M11.5 7H13.5V9H11.5V7ZM11.5 11H13.5V17H11.5V11ZM12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20Z" fill="#1D4ED8"/>
            </svg></span>
            @if (isAppInternalOnly) {
            <div class="internal-only-message-container">
              <mat-icon> warning_amber </mat-icon>
              <span class="internal-only-warning-message">{{'Application_Setup.internlonly_warning_message'|translate }}
              </span>
            </div>
            }
      </div>
    </div>
    </div>
    }
  </div>

  </mat-dialog-content>
  <mat-dialog-actions>
    <div>
    <button  mat-stroked-button (click)="cancel()" class="close-btn">{{'Application_Setup.close_button' | translate}}</button>
    </div>
    <div>
    @if (!continueToAppSetUp) {
    <button (click)="continueAppSetUp()" color="primary" mat-raised-button
    aria-label="'This is a sample button'">{{'Application_Setup.continue_button' | translate}}</button>
    }
    @if (continueToAppSetUp) {
    <button (click)="setUpApplication()" color="primary" mat-raised-button>
      {{'Application_Setup.setup_button' | translate}}
    </button>
    }
  </div>
  </mat-dialog-actions>
  @if (loading) {
  <app-spinner></app-spinner>
  }

  